import type { FaireProductEntity } from "../../entity_types/product";

export const p_7njzry9swa: FaireProductEntity = {
  token: "p_7njzry9swa",
  type: "product",
  name: "Hot Garlic Chili Crisp — Spicy (16oz) All Natural",
  brandToken: "b_qe6cjwf7wv",
  brandName: "Mama Teav's",
  imageUrl:
    "https://cdn.faire.com/fastly/024498a0d447c93fb7fb4cb5f2bdbbd7d1bf3d5c7348e70905b1d5056219a5ab.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4e872a6f65a467d6b4cd48a4453973ca2a2ecbe2b3f8edc5a8c91d8db27b6e3.webp",
    "https://cdn.faire.com/fastly/d376a96ab21c52f4b4d92e30d818d838cd22453af4d5f306ffe46c9b3d841991.jpeg",
    "https://cdn.faire.com/fastly/49484f59cda4f20a6ec35d2381811b70d56f2e4583df6823aa619b7502e0311b.webp",
  ],
  priceDollars: 22,
  description:
    "By popular demand, our large 16 oz jars are officially available on Faire. \n\nHotter than your first time, spicier than our mom’s takes. \n\nHot Garlic Chili Crisp - Spicy is the original fire-starter. The crunch that built the cult, the umami that changed your brain chemistry, the heat that reminds you you’re alive. This jar will save you from a blandwich. Makes rice extra nice. Transforms pizza, toast, soups or noodles. Share a spoonful and gain a friend. Hoard the jar and risk karmic retribution—mom’s superstition, not ours. \n\nSeven whole ingredients. Infinite uses. Our Chili Crisp keeps it simple so the flavor can speak for itself —bold heat, savory depth, and a satisfying crunch that makes everything taste better. Whether your customers are heat-seekers or just great-food lovers, this is the one condiment they didn't know they needed.\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:55.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
